module.exports = __webpack_public_path__ + "static/media/Circle-Words-Wordmark.665f2f5d.png";